import React from 'react';
import PropTypes from 'prop-types';

import { format, useMessages } from '../i18n';
import { courseCodeOf } from './progress';
import useCourseProgress from './useCourseProgress';

// The course banner at the top of every course page (patched into
// LoadedTabPage by thervumitra/patch-learning.js): course code, name and progress.
const CourseBanner = ({ courseId, title }) => {
  const t = useMessages();
  const pct = useCourseProgress(courseId);
  const code = courseCodeOf(courseId);
  return (
    <section className="bm-course-banner">
      <div className="container-xl">
        {code && <span className="bm-course-banner__code">{code}</span>}
        <div className="bm-course-banner__title">{title}</div>
        {pct !== null && (
          <div
            className="bm-course-banner__progress"
            role="progressbar"
            aria-label={t.lhCourseProgress}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={pct}
          >
            <span className="bm-course-banner__bar" aria-hidden="true"><span style={{ width: `${pct}%` }} /></span>
            <span>{format(t.lhProgress, { pct })}</span>
          </div>
        )}
      </div>
    </section>
  );
};

CourseBanner.propTypes = { courseId: PropTypes.string.isRequired, title: PropTypes.string };
CourseBanner.defaultProps = { title: '' };

export default CourseBanner;
